import { useState } from 'react';
import styled, { CSSProperties } from 'styled-components';
import { Tab } from './Tab';

interface TabInfo {
  text: string;
  element: JSX.Element;
  handleTabClick?: () => void;
}

interface TabContainerProps {
  tabInfos: TabInfo[];
  defaultSelectedTabIndex?: number;
  style?: CSSProperties;
}

export const TabContainer = ({ tabInfos, defaultSelectedTabIndex, style }: TabContainerProps) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(defaultSelectedTabIndex ?? 0);

  return (
    <>
      <Container style={{ ...style }}>
        {tabInfos.map((tabInfo, tabIndex) => (
          <Tab
            key={tabInfo.text}
            isActive={selectedTabIndex === tabIndex}
            text={tabInfo.text}
            handleClick={() => {
              if (tabInfo.handleTabClick) {
                tabInfo.handleTabClick();
              }
              setSelectedTabIndex(tabIndex);
            }}
          />
        ))}
        <ActiveTabIndicator totalTabLength={tabInfos.length} selectedTabIndex={selectedTabIndex} />
      </Container>
      {tabInfos[selectedTabIndex].element}
    </>
  );
};

const Container = styled.div`
  width: 100%;
  height: 40px;

  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;

  &::after {
    content: '';
    background: var(--Light-Scheme-Monochrome-grey20, #e4e4ed);
    width: 100%;
    height: 1px;
    position: absolute;
    top: 39px;
  }
`;

const ActiveTabIndicator = styled.div<{ totalTabLength: number; selectedTabIndex: number }>`
  z-index: 1;
  position: absolute;
  height: 3px;
  background: var(--Light-Scheme-Monochrome-black, #232429);
  width: ${(props) => `calc(100% / ${props.totalTabLength})`};
  left: ${(props) => `calc((100% / ${props.totalTabLength}) * ${props.selectedTabIndex})`};

  bottom: 0;
  transition: all 0.3s ease;
`;
